import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GeoOutputType } from "@/lib/types";
import { GEO_OUTPUT_TYPES } from "@/data/geo-constants";

type GeoOutputTypeSelectProps = {
  value: GeoOutputType | "";
  onChange: (value: GeoOutputType) => void;
};

export function GeoOutputTypeSelect({ value, onChange }: GeoOutputTypeSelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-background/50 border-border/30">
        <SelectValue placeholder="Select output type" />
      </SelectTrigger>
      <SelectContent>
        {GEO_OUTPUT_TYPES.map((type) => (
          <SelectItem key={type.value} value={type.value}>
            <div className="flex items-center gap-2">
              <span>{type.icon}</span>
              <span>{type.label}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
